import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleError } from "@low6dev/react-utils";
import axios from "axios";
import moment from "moment";
import qs from "qs";
import history from "router/history";
import { logXtremePush } from "utils";
import { setAuth } from "components/feature/auth/actions";

const useCheckAuth = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if (process.env.REACT_APP_SSO_DISABLED === "true") {
        const profileRes = await axios.get("/me");

        const profile = profileRes?.data?.data;

        const age = moment().diff(
          moment(profile?.birthDate, "YYYY-MM-DD"),
          "years",
          true
        );

        const isOver24 = age >= 24;

        dispatch(
          setAuth({
            userId: profile?.id,
            dpgAgeVerified: profile?.dpgAgeVerified,
            isLoggedIn: true,
            isAuthChecked: true,
            isOver24,
          })
        );

        history.push("/");

        //alert("its this dude!");
        // window.location.reload();
        return;
      }

      try {
        const token = qs.parse(window?.location?.search, {
          ignoreQueryPrefix: true,
        }).access_token;

        console.log("token", token);

        if (token) {
          if (process.env.NODE_ENV !== "development") {
            setTimeout(() => {
              window.history.pushState({}, document.title, "/");
            }, 2000);
          }

          const authResponse = await axios.post(`/sso/auth/login-by-token`, {
            token,
          });

          dispatch(
            setAuth({
              isLoggedIn: true,
            })
          );

          const accessToken = authResponse?.data?.access_token;

          localStorage.setItem("fiver_react_access_token", accessToken);
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${accessToken}`;

          console.log("authResponse", authResponse);

          const profileRes = await axios.get("/me");

          dispatch(
            setAuth({
              dpgAgeVerified: profileRes?.data?.data?.dpgAgeVerified,
              userId: profileRes?.data?.data?.id,
              isLoggedIn: true,
            })
          );
        } else if (
          process.env.NODE_ENV === "development" &&
          localStorage.getItem("fiver_react_access_token")
        ) {
          const profileRes = await axios.get("/me");

          dispatch(
            setAuth({
              dpgAgeVerified: profileRes?.data?.data?.dpgAgeVerified,
              userId: profileRes?.data?.data?.id,
              isLoggedIn: true,
            })
          );

          window.xtremepush("set", "user_id", profileRes?.data?.data?.id);
          logXtremePush("event", "login_checked");

          console.log("we have token");
          history.push("/");

          //alert("its this dude!");
          // window.location.reload();
        } else {
          // dispatch(
          //   setAuth({
          //     isLoggedIn: false,
          //   })
          // );
          history.push("/sso-error");
        }

        dispatch(
          setAuth({
            isAuthChecked: true,
          })
        );
      } catch ({ response }) {
        // dispatch(
        //   setAuth({
        //     isLoggedIn: false,
        //   })
        // );
        dispatch(
          setAuth({
            isAuthChecked: true,
          })
        );
        console.log("errorResponse", response);
        handleError(response);
        history.push("/sso-error");
      }
    })();
  }, []);
};

export default useCheckAuth;
